// PRD-098: Disposable email blocklist validation
// Lazy-loaded blocklist to avoid bundling ~86KB on every page
let _blocklist = null;

export async function loadBlocklist() {
  if (_blocklist) return _blocklist;
  // Dynamic import to keep it out of main bundle
  const list = await import('../data/disposable-email-domains.json');
  _blocklist = new Set(Array.isArray(list.default) ? list.default : list);
  return _blocklist;
}

export async function isDisposableEmail(email) {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  const blocklist = await loadBlocklist();
  return blocklist.has(domain);
}

// PRD-098: Admin/test email bypass — only exact org domain, NOT prefix matching
// SECURITY: Never use startsWith('test') — attackers can register test123@mailinator.com to bypass
export function isTestEmail(email) {
  const lower = (email || '').toLowerCase();
  return lower.endsWith('@theorbitalledger.com');
}
